.select {
  width: 100%;

  :global(.ant-select-selection-search) {
    padding-left: var(--padding-left);
  }
}

.tag {
  display: flex;
  align-items: center;
  font-size: 13px;
  gap: 6px;
}
